/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { USE_OBSERVABLE_STATE_ERROR, USE_OBSERVABLE_STATE_PENDING } from '@squiz/dxp-console-support';
import { EmptyState, EmptyStateProps, ICON_ERROR, ICON_SITE_ADD, Loader } from '@squiz/sds';
import {
  EntityTenantSetting,
  TenantDomainValue,
  useTenantSiteList,
} from 'apps/console-core/src/Services/tenant-settings';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { MonitoringSiteListItem } from '../MonitoringSiteListItem/MonitoringSiteListItem';
import { MONITORING_SITE_LIST_STRINGS } from './MonitoringSiteList.constants';

export const MonitoringSiteList = (): JSX.Element => {
  const { t } = useTranslation();
  const labels = {
    errorStateHeading: t(MONITORING_SITE_LIST_STRINGS.errorStateHeading),
    errorStateSubheading: t(MONITORING_SITE_LIST_STRINGS.errorStateSubheading),
    heading: t(MONITORING_SITE_LIST_STRINGS.emptyStateHeading),
    subheading: t(MONITORING_SITE_LIST_STRINGS.emptyStateSubheading),
  };
  const filteringFn = (site: EntityTenantSetting<TenantDomainValue>): boolean | undefined => site.value.collectStats;
  const [siteList, state] = useTenantSiteList({ filteringFn });

  const loading = state === USE_OBSERVABLE_STATE_PENDING;
  const emptyStateProps: EmptyStateProps = {
    caption: labels.subheading,
    isLite: true,
    svg: ICON_SITE_ADD,
    title: labels.heading,
  };

  const errorEmptyStateProps: EmptyStateProps = {
    caption: t(MONITORING_SITE_LIST_STRINGS.errorStateSubheading),
    isLite: true,
    svg: ICON_ERROR,
    title: t(MONITORING_SITE_LIST_STRINGS.errorStateHeading),
  };

  if (state === USE_OBSERVABLE_STATE_ERROR) {
    return (
      <div className="monitoring__site-list error">
        <EmptyState {...errorEmptyStateProps} />
      </div>
    );
  }

  if (loading && !siteList) {
    return (
      <div className="monitoring__site-list loading">
        <Loader />
      </div>
    );
  }

  if (!siteList?.length && !loading) {
    return (
      <div className="monitoring__site-list empty">
        <EmptyState {...emptyStateProps} />
      </div>
    );
  }
  return (
    <div className="monitoring__site-list">
      {(siteList as Array<EntityTenantSetting>).map((site: EntityTenantSetting) => {
        return <MonitoringSiteListItem key={site.settingKey} url={site.settingKey} />;
      })}
    </div>
  );
};
